import { customAxiosInstanceMutator } from './custom-axios-instance';

/**
 * Birthday greetings through the notification service. Sending reuses the scheduled greeting's
 * template and its once-a-day check, so a hand greeting and an automatic one never double up.
 */

export type BirthdayGreetingResult = 'SENT' | 'ALREADY_SENT' | 'NO_NUMBER' | 'SWITCHED_OFF';

export interface BirthdayGreeting {
  customerNumber: string;
  /** EMAIL or SMS */
  channel?: string;
  /** The email address or phone number it went to. */
  recipient?: string;
  status?: string;
  sentAt?: string;
}

/** SMS one director their birthday greeting (never email: the business, 23 Oct 2026). */
export const greetDirectorBirthday = (customerNumber: string, directorId: string) =>
  customAxiosInstanceMutator<{ result: BirthdayGreetingResult }>({
    url: '/notification/api/v1/birthdays/greet',
    method: 'POST',
    params: { customerNumber, directorId }
  });

/** Birthday greetings sent between two days (yyyy-MM-dd, inclusive). */
export const getBirthdayGreetings = (from: string, to: string) =>
  customAxiosInstanceMutator<BirthdayGreeting[]>({
    url: '/notification/api/v1/birthdays/greetings',
    method: 'GET',
    params: { from, to }
  });
